var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M9.261 4h6.546L20 8.227v6.512L15.739 19H9.227L5 14.756V8.26L9.261 4zm5.898 13.705l3.546-3.546V8.807l-3.478-3.495H9.841L6.295 8.841v5.335l3.546 3.529h5.318zm-6.747-9.75l.903 1.84 1.364-3.647h1.517v10.67h-1.432V9.812l-1.278 3.341-1.125-2.505v4.397l-1.296-1.312V9.216l1.347-1.262zm4.785 8.863V6.148h1.67l3.069 3.119v1.193H16.64V9.95L14.63 7.852v7.261s1.722-1.687 1.892-1.892c.17-.204.153-.477-.085-.443h-.887v-1.295h2.387v2.25l-3.102 3.085h-1.637z"
  })));
}
export default SvgMg;